import React from 'react';
import { Button, TextInput, Toggle } from '@carbon/react';

const GeneralSettingsTab: React.FC = () => (
  <div className="settings-page__panel" style={{ minWidth: 600}}>
    <h3>General settings</h3>
    <div className="settings-page__form-grid">
      <TextInput id="org-name" labelText="Organization name" placeholder="XD Media" />
      <TextInput id="timezone" labelText="Default timezone" placeholder="UTC" />
    </div>
    <div className="settings-page__permission">
      <div>
        <h4>Notifications</h4>
      </div>
      <Toggle id="notifications-toggle" labelA="Off" labelB="On" defaultToggled />
    </div>
    <div className="settings-page__actions">
      <Button kind="secondary">Discard</Button>
      <Button kind="primary">Save changes</Button>
    </div>
  </div>
);

export default GeneralSettingsTab;
